import React, {useEffect} from 'react';
import {useFormikContext} from "formik";
import {Typography} from "@material-ui/core";

function DependantField(props) {
    const {values, setFieldValue} = useFormikContext();
    const {options, dependantField, dependsOn} = props;

    useEffect(() => {
        if (values[dependsOn['name']] && values[dependsOn['name']] !== "") {
            const opt = options.find(op => op.value === values[dependsOn['name']]);
            if (opt && opt[dependantField.name])
                setFieldValue(dependantField.name, opt[dependantField.name]);
        }
    }, [values[dependsOn['name']]]);

    return (
        <>
            <div style={{display: 'flex', flexDirection: 'column'}}>
                <Typography style={{
                    fontFamily: 'Work Sans, sans-serif',
                    fontWeight: 400,
                    fontSize: '12px',
                    color: 'rgba(0, 0, 0, 0.54)'
                }}>{dependantField.label}</Typography>
                <div style={{
                    marginTop: '4px',
                    padding: '4px 8px',
                    border: 'solid 1px #c5c5c5',
                    width: '100%',
                    borderRadius: '4px',
                    backgroundColor: '#d5d5d5',
                    boxShadow: '0 2px 3px 0 rgba(56,56,56,0.15)',
                    height: "32px"
                }}>
                    <Typography style={{
                        color: '#808080',
                        letterSpacing: '-0.5px',
                        fontSize: '14px',
                        marginTop: "2px"
                    }}>{values[dependantField['name']]}</Typography>
                </div>
            </div>
        </>
    );
}

export default DependantField;